import { takeEvery, put, select } from 'redux-saga/effects'

import { SET_SELECTED_ID } from 'actions/navigator'
import { setIsDrawerVisible } from 'actions/drawer'
import { getIsDrawerVisible } from 'selectors/drawer'

export function* watchSelectedId() {
  yield takeEvery(SET_SELECTED_ID, toggleDrawer)
}

function* toggleDrawer(action) {
  const { id, withDrawer } = action

  if (withDrawer) {
    if (id) {
      const isDrawerVisible = yield select(getIsDrawerVisible)

      if (!isDrawerVisible) yield put(setIsDrawerVisible(true))
    } else yield put(setIsDrawerVisible(false))
  }
}
